import { heroTags, heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">

          <div className="flex-1 w-full text-center lg:text-left space-y-6 md:space-y-8">
            <div className="flex flex-wrap justify-center lg:justify-start gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-900 leading-tight tracking-tight">
              51影院
              <span className="block text-2xl md:text-3xl lg:text-4xl font-bold text-primary-600 mt-2">
                免费高清在线影视大全
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading italic">
              整合第九影院、yy影院、看吧影院、九九影院、18影院优质资源
            </p>

            <p className="text-sm md:text-base text-foreground-500 max-w-2xl leading-relaxed mx-auto lg:mx-0">
              51影院为您一站式整合第九影院、yy影院、看吧影院、九九影院和18影院的丰富影视资源，
              每日更新300+部影片，涵盖院线大片、热门剧集、经典老片和独家专题。
              高清画质、纯净播放、无广告打扰，打开浏览器即可畅享极致观影体验。
              当前暑期档热片扎堆，国产科幻与韩剧悬疑齐飞，精彩不容错过。
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3 md:gap-4 pt-2">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); handleScroll('#cards'); }}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-3.5 rounded-full border-2 border-primary-300 text-primary-600 font-semibold text-sm md:text-base hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-fill text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-400/20 via-accent-400/20 to-secondary-400/20 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cinema%20visual%20with%20film%20projector%20and%20glowing%20screen%2C%20dark%20theater%20ambience%2C%20golden%20light%20beams%2C%20cinematic%20atmosphere%2C%20elegant%20composition%2C%20warm%20gold%20and%20deep%20red%20accents%2C%20artistic%20abstract%20style%2C%20clean%20background&width=700&height=900&seq=hero-visual&orientation=portrait"
                alt="51影院 - 免费高清在线影视大全"
                className="relative w-full h-auto rounded-2xl object-cover"
                title="51影院 - 第九影院与yy影院免费高清在线看"
                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}